import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { Form } from 'antd';
import { AllowedEmailDomainsEnforcementLevel, User } from '@bringg/types';
import { useTranslation } from 'react-i18next';
import { useAllowedEmailDomainValidator } from '@bringg-frontend/hooks';

import { getValidateMessages } from '../../../utils/validate-messages';
import { useCompaniesForDriverForm, useHasFeatureFlag } from 'bringg-web';
import { ENABLE_USER_WELCOME_URL_EDIT } from '../consts';
import {
	AddressField,
	CompanyField,
	DefaultWelcomeUrlField,
	EmailField,
	ExternalIDField,
	JobDescriptionField,
	LanguageField,
	NameField,
	PasswordField,
	PhoneField,
	TeamsField,
	UserPrivilegesField
} from '../form-fields';

interface Props {
	form: any;
	onSubmit: (user: Partial<User & { password: string }>) => void;
}

export default function DispatcherForm({ form, onSubmit }: Props) {
	const { t } = useTranslation();
	const { companies } = useCompaniesForDriverForm();
	const enableUserWelcomeUrlEdit = useHasFeatureFlag(ENABLE_USER_WELCOME_URL_EDIT);
	const emailDomainValidator = useAllowedEmailDomainValidator(
		AllowedEmailDomainsEnforcementLevel.AdminsAndDispatchers
	);

	return (
		<Form
			validateMessages={getValidateMessages(t)}
			validateTrigger={['onBlur']}
			autoComplete="do-not-autofill"
			scrollToFirstError
			colon={false}
			onFinish={onSubmit}
			form={form}
			className="dispatcher-form"
		>
			<div className="form-group">
				<h4>{t('CREATE_USER_MODAL.MANDATORY_DETAILS')}</h4>
				<NameField />
				<ExternalIDField />
				<EmailField required validator={emailDomainValidator} />
				<PasswordField required />
				<PhoneField required={false} />
				<AddressField form={form} />
				<TeamsField required />
				<UserPrivilegesField required />
				<CompanyField companies={companies} />
				<JobDescriptionField />
				<LanguageField />
				{enableUserWelcomeUrlEdit && <DefaultWelcomeUrlField />}
			</div>
		</Form>
	);
}
